__turbopack_context__.v({
  "count": "Tabs-module__JlQDyq__count",
  "default": "Tabs-module__JlQDyq__default",
  "indicator": "Tabs-module__JlQDyq__indicator",
  "pills": "Tabs-module__JlQDyq__pills",
  "tab": "Tabs-module__JlQDyq__tab",
  "tabActive": "Tabs-module__JlQDyq__tabActive",
  "tabDisabled": "Tabs-module__JlQDyq__tabDisabled",
  "tabIcon": "Tabs-module__JlQDyq__tabIcon",
  "tabLabel": "Tabs-module__JlQDyq__tabLabel",
  "tabs": "Tabs-module__JlQDyq__tabs",
  "tabs--lg": "Tabs-module__JlQDyq__tabs--lg",
  "tabs--md": "Tabs-module__JlQDyq__tabs--md",
  "tabs--sm": "Tabs-module__JlQDyq__tabs--sm",
  "underline": "Tabs-module__JlQDyq__underline",
});
